import { pushScopeId, popScopeId, openBlock, createElementBlock, normalizeClass, createElementVNode } from 'vue';

var mixin = {
  props: {
    color: {
      default: '#00a6b6'
    },
    keepMargin: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    fill: function fill() {
      return this.color;
    }
  }
};

var script$h = {
  mixins: [mixin]
};

pushScopeId("data-v-755033ca");

var _hoisted_1$h = {
  transform: "translate(19 13)"
};
var _hoisted_2$g = ["fill"];

popScopeId();

function render$h(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "48",
    height: "48",
    class: normalizeClass({
      'remove-margin': !_ctx.keepMargin
    }),
    viewBox: "0 0 48 48"
  }, [createElementVNode("g", _hoisted_1$h, [createElementVNode("path", {
    fill: _ctx.color,
    d: "M6.65,22V11H9.608L10,7.208H6.65l.005-1.9c0-.989.092-1.519,1.475-1.519H9.979V0H7.02c-3.554,0-4.8,1.839-4.8,4.932V7.208H0V11H2.215V22Z"
  }, null, 8, _hoisted_2$g)])], 2);
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$h = ".remove-margin[data-v-755033ca] {\n  margin: -13px;\n}";
styleInject(css_248z$h);

script$h.render = render$h;
script$h.__scopeId = "data-v-755033ca";

var script$g = {
  mixins: [mixin]
};

pushScopeId("data-v-7f858cfd");

var _hoisted_1$g = {
  transform: "translate(14 12)"
};
var _hoisted_2$f = ["fill"];

popScopeId();

function render$g(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "48",
    height: "48",
    class: normalizeClass({
      'remove-margin': !_ctx.keepMargin
    }),
    viewBox: "0 0 48 48"
  }, [createElementVNode("g", _hoisted_1$g, [createElementVNode("path", {
    fill: _ctx.fill,
    d: "M17.81,22A17.83,17.83,0,0,0,0,4.191V0A22.025,22.025,0,0,1,22,22Zm-7.333,0A10.489,10.489,0,0,0,0,11.524V7.333A14.684,14.684,0,0,1,14.667,22ZM0,18.858A3.143,3.143,0,1,1,3.142,22,3.143,3.143,0,0,1,0,18.858Z",
    transform: "translate(0)"
  }, null, 8, _hoisted_2$f)])], 2);
}

var css_248z$g = ".remove-margin[data-v-7f858cfd] {\n  margin: -13px;\n}";
styleInject(css_248z$g);

script$g.render = render$g;
script$g.__scopeId = "data-v-7f858cfd";

var script$f = {
  mixins: [mixin]
};

pushScopeId("data-v-37f01095");

var _hoisted_1$f = {
  transform: "translate(14 14)"
};
var _hoisted_2$e = ["fill"];

popScopeId();

function render$f(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "48",
    height: "48",
    class: normalizeClass(["icon", {
      'remove-margin': !_ctx.keepMargin
    }]),
    viewBox: "0 0 48 48"
  }, [createElementVNode("g", _hoisted_1$f, [createElementVNode("path", {
    fill: _ctx.fill,
    class: "b",
    d: "M1.1,14.489l3.3-2.511a6.131,6.131,0,0,0,5.8,4.156,6.128,6.128,0,0,0,3.538-1l3.22,2.445A9.843,9.843,0,0,1,10.2,20,10.2,10.2,0,0,1,1.1,14.489Zm12.642.644a4.876,4.876,0,0,0,2.086-3.244H10.2V8.178h9.581A8.384,8.384,0,0,1,20,10.222a9.682,9.682,0,0,1-3.039,7.356ZM0,10a9.851,9.851,0,0,1,1.088-4.49l3.3,2.511A6.376,6.376,0,0,0,4.058,10a6.058,6.058,0,0,0,.34,1.977L1.088,14.489A9.85,9.85,0,0,1,0,10Zm1.088-4.49A10.221,10.221,0,0,1,10.2,0,9.917,9.917,0,0,1,17.03,2.6l-2.88,2.756A5.713,5.713,0,0,0,10.2,3.867,6.157,6.157,0,0,0,4.387,8.022Z"
  }, null, 8, _hoisted_2$e)])], 2);
}

var css_248z$f = ".remove-margin[data-v-37f01095] {\n  margin: -13px;\n}";
styleInject(css_248z$f);

script$f.render = render$f;
script$f.__scopeId = "data-v-37f01095";

var script$e = {
  mixins: [mixin]
};

pushScopeId("data-v-b3c816c0");

var _hoisted_1$e = {
  transform: "translate(13 13)"
};
var _hoisted_2$d = ["fill"];
var _hoisted_3$3 = ["fill"];
var _hoisted_4$2 = ["fill"];

popScopeId();

function render$e(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: normalizeClass(["icon", {
      'remove-margin': !_ctx.keepMargin
    }]),
    width: "48",
    height: "48",
    viewBox: "0 0 48 48"
  }, [createElementVNode("g", _hoisted_1$e, [createElementVNode("path", {
    fill: _ctx.fill,
    stroke: "rgba(0, 0, 0, 0)",
    "stroke-miterlimit": "10",
    d: "M11,22c-2.986,0-3.374-.012-4.535-.066a8.112,8.112,0,0,1-2.67-.511A5.632,5.632,0,0,1,.577,18.206a8.173,8.173,0,0,1-.511-2.67C.013,14.347,0,13.954,0,11S.013,7.653.066,6.465a8.1,8.1,0,0,1,.511-2.67,5.409,5.409,0,0,1,1.27-1.949A5.38,5.38,0,0,1,3.8.578,8.116,8.116,0,0,1,6.466.066C7.653.012,8.046,0,11,0s3.345.012,4.534.066a8.155,8.155,0,0,1,2.673.512,5.394,5.394,0,0,1,1.948,1.268,5.45,5.45,0,0,1,1.27,1.949,8.238,8.238,0,0,1,.511,2.67C21.987,7.652,22,8.045,22,11s-.013,3.346-.066,4.534a8.238,8.238,0,0,1-.511,2.67,5.642,5.642,0,0,1-3.218,3.218,8.114,8.114,0,0,1-2.671.511C14.373,21.988,13.985,22,11,22ZM10.014,1.979c-2.059,0-2.444.016-3.458.062a6.035,6.035,0,0,0-2.043.38,3.4,3.4,0,0,0-1.265.823,3.412,3.412,0,0,0-.823,1.265,6.079,6.079,0,0,0-.378,2.043c-.052,1.148-.064,1.494-.064,4.443s.011,3.3.064,4.446a6.079,6.079,0,0,0,.378,2.043,3.408,3.408,0,0,0,.823,1.263,3.408,3.408,0,0,0,1.265.823,6.11,6.11,0,0,0,2.043.38c1.15.052,1.5.064,4.446.064s3.3-.011,4.444-.064a6.088,6.088,0,0,0,2.043-.38,3.648,3.648,0,0,0,2.088-2.086,6.113,6.113,0,0,0,.378-2.041c.052-1.15.064-1.5.064-4.444s-.011-3.294-.064-4.443a6.135,6.135,0,0,0-.378-2.043,3.416,3.416,0,0,0-.823-1.265,3.4,3.4,0,0,0-1.265-.823,6.114,6.114,0,0,0-2.043-.378C14.287,1.993,13.94,1.982,11,1.982h-.987Z"
  }, null, 8, _hoisted_2$d), createElementVNode("path", {
    fill: _ctx.fill,
    d: "M1.536,0A1.536,1.536,0,1,0,3.072,1.536,1.536,1.536,0,0,0,1.536,0Z",
    transform: "translate(15.206 3.723)"
  }, null, 8, _hoisted_3$3), createElementVNode("path", {
    fill: _ctx.fill,
    stroke: "rgba(0, 0, 0, 0)",
    "stroke-miterlimit": "10",
    d: "M4.774,9.547A4.773,4.773,0,1,1,9.547,4.774,4.779,4.779,0,0,1,4.774,9.547Zm0-7.872a3.1,3.1,0,1,0,3.1,3.1A3.1,3.1,0,0,0,4.774,1.675Z",
    transform: "translate(6.228 6.226)"
  }, null, 8, _hoisted_4$2)])], 2);
}

var css_248z$e = ".remove-margin[data-v-b3c816c0] {\n  margin: -13px;\n}";
styleInject(css_248z$e);

script$e.render = render$e;
script$e.__scopeId = "data-v-b3c816c0";

var script$d = {
  mixins: [mixin]
};

pushScopeId("data-v-cc0c284a");

var _hoisted_1$d = {
  transform: "translate(13 13)"
};
var _hoisted_2$c = ["fill"];

popScopeId();

function render$d(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "48",
    height: "48",
    class: normalizeClass({
      'remove-margin': !_ctx.keepMargin
    }),
    viewBox: "0 0 48 48"
  }, [createElementVNode("g", _hoisted_1$d, [createElementVNode("path", {
    class: "b",
    fill: _ctx.fill,
    d: "M1.721,19.708a5.883,5.883,0,0,1-.06-8.255L4.6,8.513a5.879,5.879,0,0,1,8.867.635.98.98,0,0,1-1.57,1.174A3.92,3.92,0,0,0,5.987,9.9L3.059,12.827A3.92,3.92,0,0,0,8.59,18.381l1.676-1.676a.98.98,0,0,1,1.386,1.386L9.963,19.779a5.879,5.879,0,0,1-8.242-.071Zm10.546-5.083a5.877,5.877,0,0,1-4.288-2.343.98.98,0,1,1,1.569-1.175,3.921,3.921,0,0,0,5.912.424L18.387,8.6a3.92,3.92,0,0,0-5.532-5.552L11.169,4.727A.98.98,0,0,1,9.787,3.336l1.7-1.686a5.88,5.88,0,0,1,8.3,8.327l-2.939,2.939a5.88,5.88,0,0,1-4.159,1.723Q12.478,14.64,12.267,14.625Z",
    transform: "translate(0 0)"
  }, null, 8, _hoisted_2$c)])], 2);
}

var css_248z$d = ".remove-margin[data-v-cc0c284a] {\n  margin: -13px;\n}";
styleInject(css_248z$d);

script$d.render = render$d;
script$d.__scopeId = "data-v-cc0c284a";

var script$c = {
  mixins: [mixin]
};

pushScopeId("data-v-9e40a3b0");

var _hoisted_1$c = {
  transform: "translate(13 13)"
};
var _hoisted_2$b = ["fill"];

popScopeId();

function render$c(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: normalizeClass(["icon", {
      'remove-margin': !_ctx.keepMargin
    }]),
    width: "48",
    height: "48",
    viewBox: "0 0 48 48"
  }, [createElementVNode("g", _hoisted_1$c, [createElementVNode("path", {
    fill: _ctx.fill,
    d: "M18.07,22V14.058c0-1.995-.713-3.356-2.5-3.356a2.7,2.7,0,0,0-2.53,1.8,3.38,3.38,0,0,0-.162,1.2V22H7.95s.065-13.451,0-14.844H12.88v2.1a4.893,4.893,0,0,1,4.444-2.452C20.568,6.807,23,8.93,23,13.489V22ZM.291,22V7.156h4.93V22ZM2.725,5.13A2.572,2.572,0,1,1,2.788,0a2.573,2.573,0,1,1-.032,5.13Z"
  }, null, 8, _hoisted_2$b)])], 2);
}

var css_248z$c = ".remove-margin[data-v-9e40a3b0] {\n  margin: -13px;\n}";
styleInject(css_248z$c);

script$c.render = render$c;
script$c.__scopeId = "data-v-9e40a3b0";

var script$b = {
  mixins: [mixin]
};

pushScopeId("data-v-89ee8d80");

var _hoisted_1$b = ["fill"];

popScopeId();

function render$b(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", {
    class: normalizeClass(["spin", {
      spin: true,
      'remove-margin': !_ctx.keepMargin
    }]),
    width: "48",
    height: "48",
    viewBox: "0 0 496 489",
    "xml:space": "preserve"
  }, [createElementVNode("path", {
    fill: _ctx.color,
    d: "M263.8,135.5v8.2c0,5.3,3.6,10,8.7,11.4c38.3,10.7,66.4,45.8,66.4,87.6c0,50.3-40.7,91-91,91c-50.3,0-91-40.7-91-91\n\tc0-41.8,28.1-76.9,66.4-87.6c5.1-1.4,8.7-6.1,8.7-11.4v-8.2c0-7.8-7.3-13.4-14.9-11.5c-53.1,13.7-92.2,62-91.9,119.4\n\tc0.4,67.8,55.1,122.1,122.9,121.9c67.6-0.1,122.3-55,122.3-122.6c0-57.2-39.1-105.2-92.1-118.8C271.1,122.1,263.8,127.8,263.8,135.5\n\tz"
  }, null, 8, _hoisted_1$b)], 2);
}

var css_248z$b = ".remove-margin[data-v-89ee8d80] {\n  margin: -13px;\n}\n.spin[data-v-89ee8d80] {\n  -webkit-animation-name: spin-89ee8d80;\n          animation-name: spin-89ee8d80;\n  -webkit-animation-duration: 2000ms;\n          animation-duration: 2000ms;\n  -webkit-animation-iteration-count: infinite;\n          animation-iteration-count: infinite;\n  -webkit-animation-timing-function: linear;\n          animation-timing-function: linear;\n}\n@-webkit-keyframes spin-89ee8d80 {\nfrom {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n}\nto {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n@keyframes spin-89ee8d80 {\nfrom {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n}\nto {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}";
styleInject(css_248z$b);

script$b.render = render$b;
script$b.__scopeId = "data-v-89ee8d80";

var script$a = {
  mixins: [mixin]
};

pushScopeId("data-v-7905b47f");

var _hoisted_1$a = {
  transform: "translate(12 15)"
};
var _hoisted_2$a = {
  transform: "translate(0)"
};
var _hoisted_3$2 = ["fill"];

popScopeId();

function render$a(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "48",
    height: "48",
    class: normalizeClass({
      'remove-margin': !_ctx.keepMargin
    }),
    viewBox: "0 0 48 48"
  }, [createElementVNode("g", _hoisted_1$a, [createElementVNode("g", _hoisted_2$a, [createElementVNode("path", {
    fill: _ctx.fill,
    d: "M-639.727-1475a3.224,3.224,0,0,1-3.272-3.167v-12.643c0-.018,0-.036,0-.055a3.226,3.226,0,0,1,3.272-3.135h17.455a3.225,3.225,0,0,1,3.272,3.167v12.666a3.224,3.224,0,0,1-3.272,3.167Zm-1.091-3.167a1.075,1.075,0,0,0,1.091,1.056h17.455a1.075,1.075,0,0,0,1.091-1.056v-10.639l-9.193,6.226a1.119,1.119,0,0,1-1.251,0l-9.193-6.226Zm9.818-6.566,9.7-6.572a1.1,1.1,0,0,0-.976-.584h-17.455a1.1,1.1,0,0,0-.976.584Z",
    transform: "translate(643 1494)"
  }, null, 8, _hoisted_3$2)])])], 2);
}

var css_248z$a = ".remove-margin[data-v-7905b47f] {\n  margin: -13px;\n}";
styleInject(css_248z$a);

script$a.render = render$a;
script$a.__scopeId = "data-v-7905b47f";

var script$9 = {
  mixins: [mixin]
};

pushScopeId("data-v-52aff8ca");

var _hoisted_1$9 = {
  transform: "translate(10.6 11.6)"
};
var _hoisted_2$9 = ["fill"];

popScopeId();

function render$9(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "48",
    height: "48",
    class: normalizeClass({
      'remove-margin': !_ctx.keepMargin
    }),
    viewBox: "0 0 48 48"
  }, [createElementVNode("g", _hoisted_1$9, [createElementVNode("path", {
    fill: _ctx.fill,
    class: "b",
    d: "M-638.811-1145.6v-4.63a11.677,11.677,0,0,1-4.789-9.332,11.528,11.528,0,0,1,3.808-8.512,13.456,13.456,0,0,1,9.192-3.526,13.458,13.458,0,0,1,9.193,3.526,11.528,11.528,0,0,1,3.808,8.512,11.527,11.527,0,0,1-3.808,8.511,13.458,13.458,0,0,1-9.193,3.526,13.981,13.981,0,0,1-3.848-.536l-4.361,2.461Zm6.89-17.627-6.628,8.15,6.031-3.843h0l3.15,3.843,6.591-8.15-5.965,3.776Z",
    transform: "translate(643.6 1171.6)"
  }, null, 8, _hoisted_2$9)])], 2);
}

var css_248z$9 = ".remove-margin[data-v-52aff8ca] {\n  margin: -13px;\n}";
styleInject(css_248z$9);

script$9.render = render$9;
script$9.__scopeId = "data-v-52aff8ca";

var script$8 = {
  mixins: [mixin]
};

pushScopeId("data-v-454bf062");

var _hoisted_1$8 = /*#__PURE__*/createElementVNode("defs", null, [/*#__PURE__*/createElementVNode("clipPath", {
  id: "a"
}, [/*#__PURE__*/createElementVNode("path", {
  class: "a",
  d: "M18.977,22c-.094,0-.189,0-.283-.013a20.992,20.992,0,0,1-9.1-3.231,20.706,20.706,0,0,1-6.335-6.321A20.973,20.973,0,0,1,.012,3.281,3.013,3.013,0,0,1,3.014,0H6.049A3.017,3.017,0,0,1,9.036,2.6a11.871,11.871,0,0,0,.648,2.6A3.019,3.019,0,0,1,9,8.375l-.721.72a15.176,15.176,0,0,0,4.61,4.6l.725-.724a3.018,3.018,0,0,1,3.179-.677,12.052,12.052,0,0,0,2.613.649A3.014,3.014,0,0,1,22,15.985V18.98A3.011,3.011,0,0,1,18.977,22ZM3.015,2.007a1,1,0,0,0-1,1.078,18.936,18.936,0,0,0,2.934,8.267,18.458,18.458,0,0,0,5.728,5.716,18.945,18.945,0,0,0,8.218,2.923c.03,0,.061,0,.092,0a1,1,0,0,0,1-1.011v-3.01a1.014,1.014,0,0,0-.855-1.042,13.935,13.935,0,0,1-3.047-.757,1,1,0,0,0-.354-.064.991.991,0,0,0-.7.287L13.755,15.67a1.007,1.007,0,0,1-1.207.162,17.075,17.075,0,0,1-6.408-6.4A1.006,1.006,0,0,1,6.3,8.23l1.273-1.27A1.006,1.006,0,0,0,7.8,5.9a13.852,13.852,0,0,1-.757-3.031,1,1,0,0,0-1.006-.862H3.015Z"
})])], -1);

var _hoisted_2$8 = /*#__PURE__*/createElementVNode("rect", {
  class: "b",
  width: "48",
  height: "48",
  rx: "24"
}, null, -1);

var _hoisted_3$1 = {
  class: "c",
  transform: "translate(13 13)"
};
var _hoisted_4$1 = {
  transform: "translate(0 0)"
};

var _hoisted_5 = /*#__PURE__*/createElementVNode("path", {
  class: "a",
  d: "M18.977,22c-.094,0-.189,0-.283-.013a20.992,20.992,0,0,1-9.1-3.231,20.706,20.706,0,0,1-6.335-6.321A20.973,20.973,0,0,1,.012,3.281,3.013,3.013,0,0,1,3.014,0H6.049A3.017,3.017,0,0,1,9.036,2.6a11.871,11.871,0,0,0,.648,2.6A3.019,3.019,0,0,1,9,8.375l-.721.72a15.176,15.176,0,0,0,4.61,4.6l.725-.724a3.018,3.018,0,0,1,3.179-.677,12.052,12.052,0,0,0,2.613.649A3.014,3.014,0,0,1,22,15.985V18.98A3.011,3.011,0,0,1,18.977,22ZM3.015,2.007a1,1,0,0,0-1,1.078,18.936,18.936,0,0,0,2.934,8.267,18.458,18.458,0,0,0,5.728,5.716,18.945,18.945,0,0,0,8.218,2.923c.03,0,.061,0,.092,0a1,1,0,0,0,1-1.011v-3.01a1.014,1.014,0,0,0-.855-1.042,13.935,13.935,0,0,1-3.047-.757,1,1,0,0,0-.354-.064.991.991,0,0,0-.7.287L13.755,15.67a1.007,1.007,0,0,1-1.207.162,17.075,17.075,0,0,1-6.408-6.4A1.006,1.006,0,0,1,6.3,8.23l1.273-1.27A1.006,1.006,0,0,0,7.8,5.9a13.852,13.852,0,0,1-.757-3.031,1,1,0,0,0-1.006-.862H3.015Z",
  transform: "translate(0 0)"
}, null, -1);

var _hoisted_6 = {
  class: "d",
  transform: "translate(0 0)"
};
var _hoisted_7 = {
  transform: "translate(-1.005 -1.003)"
};
var _hoisted_8 = ["fill"];

popScopeId();

function render$8(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    width: "48",
    height: "48",
    class: normalizeClass({
      'remove-margin': !_ctx.keepMargin
    }),
    viewBox: "0 0 48 48"
  }, [_hoisted_1$8, _hoisted_2$8, createElementVNode("g", _hoisted_3$1, [createElementVNode("g", _hoisted_4$1, [_hoisted_5, createElementVNode("g", _hoisted_6, [createElementVNode("g", _hoisted_7, [createElementVNode("rect", {
    fill: _ctx.fill,
    width: "24.122",
    height: "24.08"
  }, null, 8, _hoisted_8)])])])])], 2);
}

var css_248z$8 = ".remove-margin[data-v-454bf062] {\n  margin: -13px;\n}\n.a[data-v-454bf062] {\n  fill: #00a6b6;\n}\n.b[data-v-454bf062] {\n  fill: none;\n}\n.c[data-v-454bf062] {\n  isolation: isolate;\n}\n.d[data-v-454bf062] {\n  -webkit-clip-path: url(#a);\n          clip-path: url(#a);\n}";
styleInject(css_248z$8);

script$8.render = render$8;
script$8.__scopeId = "data-v-454bf062";

var script$7 = {
  mixins: [mixin]
};

var _hoisted_1$7 = {
  transform: "translate(16 13)"
};
var _hoisted_2$7 = ["fill"];
function render$7(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: normalizeClass(["icon", {
      'remove-margin': !_ctx.keepMargin
    }]),
    width: "48",
    height: "48",
    viewBox: "0 0 48 48"
  }, [createElementVNode("g", _hoisted_1$7, [createElementVNode("path", {
    fill: _ctx.fill,
    class: "b",
    d: "M222.683,145.881a19.929,19.929,0,0,1,.785-8.154c.269-1.011.508-2.031.776-3.042a1.262,1.262,0,0,0-.064-.8,4.468,4.468,0,0,1,.524-4.253,1.914,1.914,0,0,1,2.525-.707,1.454,1.454,0,0,1,.88,1.307,6.46,6.46,0,0,1-.371,2.264,23.8,23.8,0,0,0-.729,2.6c-.342,1.95.941,3.045,2.819,2.41a3.251,3.251,0,0,0,1.724-1.374,8.088,8.088,0,0,0,.976-7.185c-.7-2.078-2.405-2.907-4.464-3.03a6.5,6.5,0,0,0-6.43,4.96,4.156,4.156,0,0,0,.523,3.389,1.929,1.929,0,0,1,.183,1.958c-.129.307-.258.416-.615.3a3.665,3.665,0,0,1-2.574-3.251,8.084,8.084,0,0,1,6.968-9.257,9.988,9.988,0,0,1,5.3.559,6.655,6.655,0,0,1,4.506,5.915,10.051,10.051,0,0,1-1.329,6.232,5.857,5.857,0,0,1-5.642,3.131,4.678,4.678,0,0,1-2.455-1.079c-.463-.33-.468-.321-.579.225a17.963,17.963,0,0,1-1.446,4.72A6.036,6.036,0,0,1,222.683,145.881Z",
    transform: "translate(-219.051 -123.881)"
  }, null, 8, _hoisted_2$7)])], 2);
}

var css_248z$7 = ".remove-margin {\n  margin: -13px;\n}\n.a {\n  fill: none;\n}";
styleInject(css_248z$7);

script$7.render = render$7;

var script$6 = {
  mixins: [mixin]
};

pushScopeId("data-v-d2b6d912");

var _hoisted_1$6 = {
  transform: "translate(14 13)"
};
var _hoisted_2$6 = ["fill"];
var _hoisted_3 = ["fill"];
var _hoisted_4 = ["fill"];

popScopeId();

function render$6(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "48",
    height: "48",
    class: normalizeClass({
      'remove-margin': !_ctx.keepMargin
    }),
    viewBox: "0 0 48 48"
  }, [createElementVNode("g", _hoisted_1$6, [createElementVNode("path", {
    fill: _ctx.fill,
    d: "M4,15a4,4,0,1,1,4-4A4,4,0,0,1,4,15ZM4,9a2,2,0,1,0,2,2A2,2,0,0,0,4,9ZM16,8a4,4,0,1,1,4-4A4,4,0,0,1,16,8Zm0-6a2,2,0,1,0,2,2A2,2,0,0,0,16,2Z",
    transform: "translate(0 0)"
  }, null, 8, _hoisted_2$6), createElementVNode("path", {
    fill: _ctx.fill,
    d: "M4,8A4,4,0,1,1,8,4,4,4,0,0,1,4,8ZM4,2A2,2,0,1,0,6,4,2,2,0,0,0,4,2Z",
    transform: "translate(12.4 14)"
  }, null, 8, _hoisted_3), createElementVNode("path", {
    fill: _ctx.fill,
    d: "M-823.039-1160.156l-6.488-3.98a1.031,1.031,0,0,1-.343-1.368.925.925,0,0,1,1.3-.36l6.488,3.98a1.028,1.028,0,0,1,.342,1.367.941.941,0,0,1-.822.5A.909.909,0,0,1-823.039-1160.156Zm-6.831-7.36a1.029,1.029,0,0,1,.341-1.367l6.479-3.981a.925.925,0,0,1,1.3.36,1.029,1.029,0,0,1-.342,1.368l-6.478,3.98a.912.912,0,0,1-.478.136A.942.942,0,0,1-829.87-1167.516Z",
    transform: "translate(835.81 1177.51)"
  }, null, 8, _hoisted_4)])], 2);
}

var css_248z$6 = ".remove-margin[data-v-d2b6d912] {\n  margin: -13px;\n}";
styleInject(css_248z$6);

script$6.render = render$6;
script$6.__scopeId = "data-v-d2b6d912";

var script$5 = {
  mixins: [mixin]
};

pushScopeId("data-v-5c52ac5c");

var _hoisted_1$5 = {
  transform: "translate(11 13)"
};
var _hoisted_2$5 = ["fill"];

popScopeId();

function render$5(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "48",
    height: "48",
    class: normalizeClass({
      'remove-margin': !_ctx.keepMargin
    }),
    viewBox: "0 0 48 48"
  }, [createElementVNode("g", _hoisted_1$5, [createElementVNode("path", {
    fill: _ctx.fill,
    d: "M10.225,14.446l-.408,6.118a1.538,1.538,0,0,0,1.2-.6l2.883-2.8,6,4.431c1.1.609,1.9.294,2.175-1.025L26.008,2.014c.4-1.616-.616-2.349-1.672-1.87L1.219,9.059C-.359,9.692-.35,10.572.931,10.965l5.933,1.852L20.6,4.151c.648-.393,1.243-.182.755.252L10.224,14.446Z"
  }, null, 8, _hoisted_2$5)])], 2);
}

var css_248z$5 = ".remove-margin[data-v-5c52ac5c] {\n  margin: -13px;\n}";
styleInject(css_248z$5);

script$5.render = render$5;
script$5.__scopeId = "data-v-5c52ac5c";

var script$4 = {
  mixins: [mixin]
};

pushScopeId("data-v-19537636");

var _hoisted_1$4 = {
  transform: "translate(12 14)"
};
var _hoisted_2$4 = ["fill"];

popScopeId();

function render$4(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: normalizeClass(["icon", {
      'remove-margin': !_ctx.keepMargin
    }]),
    width: "48",
    height: "48",
    viewBox: "0 0 48 48"
  }, [createElementVNode("g", _hoisted_1$4, [createElementVNode("path", {
    fill: _ctx.fill,
    class: "b",
    d: "M11.653,5.32l.052.865-.867-.106a14.059,14.059,0,0,1-8.254-4.1L1.439.836l-.295.847A5.127,5.127,0,0,0,2.22,6.909c.694.741.538.847-.659.406a2.03,2.03,0,0,0-.815-.194A6.368,6.368,0,0,0,1.37,9.487a5.62,5.62,0,0,0,2.376,2.26l.85.406L3.59,12.17c-.971,0-1.006.018-.9.388a5.258,5.258,0,0,0,3.243,2.9l1.075.371-.936.565A9.7,9.7,0,0,1,1.422,17.7,5.094,5.094,0,0,0,0,17.837a13.144,13.144,0,0,0,3.347,1.554,14.54,14.54,0,0,0,11.376-1.306,15.318,15.318,0,0,0,5.775-6.85,18.34,18.34,0,0,0,1.179-5.3c0-.812.052-.918,1.023-1.889A11.5,11.5,0,0,0,23.914,2.69c.173-.335.156-.335-.728-.035-1.474.53-1.682.459-.954-.335A5.143,5.143,0,0,0,23.411.43c0-.053-.26.035-.555.194a9.627,9.627,0,0,1-1.526.6l-.936.3-.85-.583A7.037,7.037,0,0,0,18.07.165a5.877,5.877,0,0,0-3.035.071A5.054,5.054,0,0,0,11.653,5.32Z"
  }, null, 8, _hoisted_2$4)])], 2);
}

var css_248z$4 = ".remove-margin[data-v-19537636] {\n  margin: -13px;\n}\n.a[data-v-19537636] {\n  fill: none;\n}";
styleInject(css_248z$4);

script$4.render = render$4;
script$4.__scopeId = "data-v-19537636";

var script$3 = {
  mixins: [mixin]
};

pushScopeId("data-v-203e4112");

var _hoisted_1$3 = {
  transform: "translate(13 11)"
};
var _hoisted_2$3 = ["fill"];

popScopeId();

function render$3(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: normalizeClass(["icon", {
      'remove-margin': !_ctx.keepMargin
    }]),
    width: "48",
    height: "48",
    viewBox: "0 0 48 48"
  }, [createElementVNode("g", _hoisted_1$3, [createElementVNode("path", {
    fill: _ctx.fill,
    class: "b",
    d: "M-334.518-552.8A9.55,9.55,0,0,1-337-559.34a9.535,9.535,0,0,1,2.349-6.434,8.243,8.243,0,0,1,6.53-3,8.693,8.693,0,0,1,3.078.535,6.351,6.351,0,0,0-.66,2.2,6.087,6.087,0,0,0-2.426-.486,6.172,6.172,0,0,0-4.691,2.117,7.267,7.267,0,0,0-1.961,5.121,7.544,7.544,0,0,0,.894,3.611,6.507,6.507,0,0,0,2.416,2.585,6.316,6.316,0,0,0,2.294.832c6.626-2.583,5.846-15.364,5.8-16.064.038.114.057.176.057.176,3.757,10.223-4.066,15.641-4.549,15.962a6.349,6.349,0,0,0,3.083-.906,6.507,6.507,0,0,0,2.416-2.585,7.554,7.554,0,0,0,.894-3.611,7.641,7.641,0,0,0-.541-2.9,6.378,6.378,0,0,0,2.079-.865,10,10,0,0,1,.681,3.716,9.55,9.55,0,0,1-2.482,6.542,8.141,8.141,0,0,1-6.381,2.8A8.159,8.159,0,0,1-334.518-552.8Zm12.576-13.326s5.134-2.867,5.326-5.3a8.834,8.834,0,0,1-5.89,4.613,3.752,3.752,0,0,1,.424-4.53,5.637,5.637,0,0,1,2.7-1.3,4.872,4.872,0,0,0,3.076-2.771,8.776,8.776,0,0,1,.861,7.377,6,6,0,0,1-2.1,2.749,3.173,3.173,0,0,1-1.646.476A3.892,3.892,0,0,1-321.942-566.124ZM-326.916-576s3.016,2.039,3.536,7.642c0,0,0,.012,0,.032A43.726,43.726,0,0,0-326.916-576Z",
    transform: "translate(337 576)"
  }, null, 8, _hoisted_2$3)])], 2);
}

var css_248z$3 = ".remove-margin[data-v-203e4112] {\n  margin: -13px;\n}\n.a[data-v-203e4112] {\n  fill: none;\n}";
styleInject(css_248z$3);

script$3.render = render$3;
script$3.__scopeId = "data-v-203e4112";

var script$2 = {
  mixins: [mixin]
};

pushScopeId("data-v-7ddd7b3d");

var _hoisted_1$2 = {
  transform: "translate(10.289 13.08)"
};
var _hoisted_2$2 = ["fill"];

popScopeId();

function render$2(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "48",
    height: "48",
    class: normalizeClass({
      'remove-margin': !_ctx.keepMargin
    }),
    viewBox: "0 0 48 48"
  }, [createElementVNode("g", _hoisted_1$2, [createElementVNode("path", {
    fill: _ctx.fill,
    d: "M-739.757-1151.08h0l-2.92-1.489-.032.009-.106.03a9.525,9.525,0,0,1-2.559.346c-4.461,0-8.09-3.034-8.09-6.764s3.629-6.764,8.09-6.764,8.086,3.034,8.086,6.764a6.41,6.41,0,0,1-3.174,5.374l-.075.047.781,2.447Zm-2.84-11.3a1.119,1.119,0,0,0-1.136,1.1,1.12,1.12,0,0,0,1.136,1.1,1.12,1.12,0,0,0,1.136-1.1A1.119,1.119,0,0,0-742.6-1162.378Zm-5.675,0a1.119,1.119,0,0,0-1.137,1.1,1.121,1.121,0,0,0,1.137,1.1,1.12,1.12,0,0,0,1.136-1.1A1.119,1.119,0,0,0-748.273-1162.378Zm-13.1,6.618v0l.925-2.895-.061-.039-.027-.017a8.605,8.605,0,0,1-2.735-2.756,6.89,6.89,0,0,1-1.022-3.6c0-4.415,4.295-8.006,9.574-8.006a10.734,10.734,0,0,1,6.262,1.95,7.768,7.768,0,0,1,3.2,4.832c-.136-.007-.279-.008-.4-.008-4.809,0-8.721,3.279-8.721,7.31a6.225,6.225,0,0,0,.3,1.91c-.2.01-.419.02-.643.02a11.3,11.3,0,0,1-3.029-.409l-.163-.047-3.459,1.761Zm10.085-13.371a1.324,1.324,0,0,0-1.344,1.3,1.325,1.325,0,0,0,1.344,1.3,1.325,1.325,0,0,0,1.344-1.3A1.324,1.324,0,0,0-751.284-1169.131Zm-6.72,0a1.325,1.325,0,0,0-1.345,1.3,1.325,1.325,0,0,0,1.345,1.3,1.326,1.326,0,0,0,1.346-1.3A1.325,1.325,0,0,0-758-1169.131Z",
    transform: "translate(764.289 1173.08)"
  }, null, 8, _hoisted_2$2)])], 2);
}

var css_248z$2 = ".remove-margin[data-v-7ddd7b3d] {\n  margin: -13px;\n}";
styleInject(css_248z$2);

script$2.render = render$2;
script$2.__scopeId = "data-v-7ddd7b3d";

var script$1 = {
  mixins: [mixin]
};

pushScopeId("data-v-761cc4c8");

var _hoisted_1$1 = {
  transform: "translate(12 11.201)"
};
var _hoisted_2$1 = ["fill"];

popScopeId();

function render$1(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "48",
    height: "48",
    class: normalizeClass({
      'remove-margin': !_ctx.keepMargin
    }),
    viewBox: "0 0 48 48"
  }, [createElementVNode("g", _hoisted_1$1, [createElementVNode("path", {
    fill: _ctx.fill,
    d: "M-705-1147.2v0l1.694-6.161a11.856,11.856,0,0,1-1.595-5.945,11.938,11.938,0,0,1,11.95-11.891,11.9,11.9,0,0,1,8.453,3.488,11.786,11.786,0,0,1,3.5,8.412,11.94,11.94,0,0,1-11.949,11.892h-.005a12,12,0,0,1-5.711-1.447L-705-1147.2Zm6.622-3.807h0l.363.214a9.973,9.973,0,0,0,5.06,1.378,9.93,9.93,0,0,0,9.947-9.884,9.8,9.8,0,0,0-2.91-6.993,9.9,9.9,0,0,0-7.029-2.9,9.928,9.928,0,0,0-9.946,9.883,9.818,9.818,0,0,0,1.52,5.26l.236.374-1,3.648,3.763-.982Zm8.547-2.58a3.851,3.851,0,0,1-1.16-.175,17.621,17.621,0,0,1-1.71-.626,12.926,12.926,0,0,1-5.073-4.414l-.027-.038,0-.005-.021-.03,0-.005a5.638,5.638,0,0,1-1.221-3.068,3.253,3.253,0,0,1,.993-2.417l.055-.059a1.1,1.1,0,0,1,.8-.375c.181,0,.389,0,.575.011h.088c.148,0,.371,0,.587.51l.21.5.013.03.077.187.012.027c.237.575.559,1.351.613,1.457a.545.545,0,0,1,.025.521l-.043.086,0,0a1.664,1.664,0,0,1-.254.4c-.035.04-.071.083-.108.127l-.049.059c-.105.128-.207.25-.293.336-.146.142-.31.3-.131.607a8.884,8.884,0,0,0,1.669,2.058,7.767,7.767,0,0,0,2.215,1.386l.022.009c.067.029.13.056.176.079a.74.74,0,0,0,.326.1.42.42,0,0,0,.324-.169c.2-.227.756-.878.95-1.165a.414.414,0,0,1,.353-.225,1,1,0,0,1,.322.077c.29.1,1.828.857,2.05.967.058.029.112.055.165.079l.006,0a.952.952,0,0,1,.4.265,2.472,2.472,0,0,1-.175,1.413,3.076,3.076,0,0,1-2.026,1.412A4.826,4.826,0,0,1-689.83-1153.589Z",
    transform: "translate(705 1171.201)"
  }, null, 8, _hoisted_2$1)])], 2);
}

var css_248z$1 = ".remove-margin[data-v-761cc4c8] {\n  margin: -13px;\n}";
styleInject(css_248z$1);

script$1.render = render$1;
script$1.__scopeId = "data-v-761cc4c8";

var script = {
  mixins: [mixin]
};

pushScopeId("data-v-40085b60");

var _hoisted_1 = {
  transform: "translate(11 15)"
};
var _hoisted_2 = ["fill"];

popScopeId();

function render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: normalizeClass(["icon", {
      'remove-margin': !_ctx.keepMargin
    }]),
    width: "48",
    height: "48",
    viewBox: "0 0 48 48"
  }, [createElementVNode("g", _hoisted_1, [createElementVNode("path", {
    fill: _ctx.fill,
    class: "b",
    d: "M-814-834c-.081,0-8.154-.006-10.158-.537a3.236,3.236,0,0,1-2.3-2.273A33.268,33.268,0,0,1-827-843a33.274,33.274,0,0,1,.544-6.189,3.239,3.239,0,0,1,2.3-2.273c2-.531,10.077-.537,10.158-.537s8.153.006,10.157.537a3.239,3.239,0,0,1,2.3,2.273A33.266,33.266,0,0,1-801-843a33.259,33.259,0,0,1-.544,6.189,3.236,3.236,0,0,1-2.3,2.273C-805.847-834.006-813.918-834-814-834Zm-2.384-12.615v8l6.4-4-6.4-4Z",
    transform: "translate(827 852)"
  }, null, 8, _hoisted_2)])], 2);
}

var css_248z = ".remove-margin[data-v-40085b60] {\n  margin: -13px;\n}\n.a[data-v-40085b60] {\n  fill: none;\n}\n.b[data-v-40085b60] {\n  stroke: rgba(0, 0, 0, 0);\n  stroke-miterlimit: 10;\n}";
styleInject(css_248z);

script.render = render;
script.__scopeId = "data-v-40085b60";

export { script$h as NIconFacebook, script$g as NIconFluxRss, script$f as NIconGoogle, script$e as NIconInstagram, script$d as NIconLink, script$b as NIconLoading, script$a as NIconMail, script$9 as NIconMessenger, script$8 as NIconPhone, script$7 as NIconPinterest, script$6 as NIconShare, script$5 as NIconTelegram, script$4 as NIconTwitter, script$3 as NIconVimeo, script$2 as NIconWechat, script$1 as NIconWhatsapp, script as NIconYoutube, script$c as NIconlinkedin };
